import { useTranslation } from 'react-i18next';
import { PaymentMethodProps } from './PaymentMethod';
import PaymentMethodOption from './PaymentMethodOption';
import TextInput from '../../inputs/TextInput';
import usePaymentFlow from '../../../hooks/payment/usePaymentFlow';
import { formatCpf, isValidCpf } from '../../../utils/cpf';

/**
 * Pix and NuPay: the Brazilian acquirer must be given the payer's CPF, so the selected row asks for
 * it. The number stays in the payment flow's memory and goes out with the checkout only.
 */
export default function TaxpayerDocumentPaymentMethod(props: PaymentMethodProps) {
  const { id, isSelected } = props;

  return <PaymentMethodOption {...props} content={isSelected ? <CpfField key={id} /> : null} />;
}

function CpfField() {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'Components:Payment:PaymentMethods:TaxpayerDocumentPaymentMethod',
  });
  const { customerDocument, setCustomerDocument } = usePaymentFlow();

  const complete = customerDocument.replace(/\D/g, '').length === 11;
  const invalid = complete && !isValidCpf(customerDocument);

  return (
    // The row itself selects the method on click; typing here must not re-trigger it.
    <div className="mt-sm mp-mask" onClick={(event) => event.stopPropagation()}>
      <label htmlFor="customer-document" className={label}>
        {t('label')}
      </label>
      <TextInput
        id="customer-document"
        inputMode="numeric"
        autoComplete="off"
        placeholder="000.000.000-00"
        value={customerDocument}
        onChange={(value) => setCustomerDocument(formatCpf(value))}
        aria-invalid={invalid}
        aria-describedby="customer-document-hint"
        data-test="customer-document-input"
      />
      <p id="customer-document-hint" className={invalid ? errorText : hint} role={invalid ? 'alert' : undefined}>
        {invalid ? t('invalid') : t('hint')}
      </p>
    </div>
  );
}

const label = 'block text-sm font-medium mb-xs text-brand-text-primary dark:text-white';
const hint = 'mt-xs text-xs text-brand-text-primary opacity-70 dark:text-white';
const errorText = 'mt-xs text-xs text-danger';
